import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { caseConstants } from '../../../constants';

import './table.scss';

const { caseActions, caseAclActions, caseCmfActions, caseCmfExtendedActions, procedureFlows, cmfExtendedProcedureFlows } = caseConstants;

const getAction = (procedureFlow, step) => {
  if (procedureFlow === procedureFlows.ACL) {
    return caseAclActions[step];
  }
  if (procedureFlow === procedureFlows.CMF) {
    return caseCmfActions[step];
  }
  if (cmfExtendedProcedureFlows.includes(procedureFlow)) {
    return caseCmfExtendedActions[step];
  }
  return caseActions[step];
};

const CaseActionCell = ({ step, access, style, numberSteps, flow }) => {
  return (
    <div style={{ color: style }} className={`case-action-cell ${access && step <= numberSteps ? 'active' : ''}`}>
      {getAction(flow, step) || ''}
    </div>
  );
};

CaseActionCell.propTypes = {
  step: PropTypes.number,
  access: PropTypes.bool,
};

export default memo(CaseActionCell);
